import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function strongPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null; // Let required validator handle empty values
    }

    const hasLowercase = /[a-z]/.test(value);
    const hasSpecialChar = /[^A-Za-z0-9]/.test(value);
    const hasCapitalOrNumber = /[A-Z0-9]/.test(value);

    const valid = hasLowercase && hasSpecialChar && hasCapitalOrNumber;

    return valid ? null : { weakPassword: true };
  };
}
